export default "__VITE_ASSET__dvNk_sH7__"